export default __webpack_public_path__ + "static/media/whatsapp-svgrepo-com.a94462ff.png";